var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-if=\"!vm.$auth.isAuthenticated()\" class=\"o-layout-primary c-main\"><main ui-view=\"\" class=\"o-layout-primary__middle\"></main></div><div ng-if=\"vm.$auth.isAuthenticated()\" ng-class=\"{'has-secondary': vm.header.hasSecondary}\" class=\"o-layout-primary c-main\"><sidebar class=\"o-layout-primary__nav\"></sidebar><main current-game-handler=\"current-game-handler\" ui-view=\"\" class=\"o-layout-primary__main js-primary-main\"></main></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app.jade
 ** module id = 877
 ** module chunks = 0
 **/